module.exports = __webpack_public_path__ + "img/arrow.aeace30e.svg";